export default "__VITE_ASSET__ac71103d__"